const DEVICE_STORAGE_KEY = "bioCV.deviceId";

const generateId = () => {
        if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
                return crypto.randomUUID();
        }
        return `device-${Math.random().toString(36).slice(2, 12)}`;
};

export const getDeviceFingerprint = () => {
        if (typeof window === "undefined") {
                return {
                        deviceId: "server-device",
                        deviceName: "Web Device",
                        userAgent: "server",
                };
        }

        let storedId;
        try {
                storedId = window.localStorage.getItem(DEVICE_STORAGE_KEY);
        } catch (error) {
                // localStorage may not be available (e.g., privacy mode)
        }

        if (!storedId) {
                const newId = generateId();
                try {
                        window.localStorage.setItem(DEVICE_STORAGE_KEY, newId);
                        storedId = newId;
                } catch (error) {
                        storedId = newId;
                }
        }

        const navigatorObj = typeof navigator !== "undefined" ? navigator : undefined;
        const platform = navigatorObj?.userAgentData?.platform || navigatorObj?.platform;
        const deviceName = platform ? `${platform} Browser` : "Web Browser";
        const userAgent = navigatorObj?.userAgent || "unknown";

        return {
                deviceId: storedId,
                deviceName,
                userAgent,
        };
};

export const resetStoredDeviceId = () => {
        if (typeof window === "undefined") return;

        try {
                window.localStorage.removeItem(DEVICE_STORAGE_KEY);
        } catch (error) {
                // Ignore storage errors
        }
};
